'use strict';

angular.module('amexReconciliationApp')
  .service('ReceiptRepository', function ($resource,
                                          $q,
                                          TransactionSearchModel,
                                          SelectedTransactionService,
                                          ActiveTransactionModel,
                                          Upload) {
    var BASE_URI = '/api/v1/receipts/search/';

    var self = this;

    self.upload = function(receipts, billingCycle) {
      if (!billingCycle) {
        billingCycle = TransactionSearchModel.billingCycle();
      }
      var uploadUrlAndData;

      var promises = _.map(receipts, function (receipt) {
        if(TransactionSearchModel.isBcaManager()) {
          uploadUrlAndData = bcaUpload(receipt, billingCycle);
        } else if(TransactionSearchModel.isAccountingManager()) {
            uploadUrlAndData  = amUpload(receipt);
        } else {
          uploadUrlAndData = nonBcaUpload(receipt, billingCycle);
        }

        return Upload.upload(uploadUrlAndData).then(function (response) {
          return response.data;
        }).catch(function (response) {
          return $q.reject(response.data.error);
        });
      });

      return $q.all(promises);
    };
    
    self.update = function(receiptDetails) {
      var requestBody = receiptDetails;

      return $resource('/api/v1/receipt/details')
        .save(requestBody)
        .$promise;
    };

    self.findUnmatchedReceipts = function (transactionIds, pagination) {
      var account = TransactionSearchModel.account();

      if(TransactionSearchModel.isAccountingManager()){
      var params = {
                    page: pagination.currentPage,
                     size: pagination.size
                    };

        return $resource(BASE_URI + 'findUnmatchedReceiptsForAccountingManager')
          .get(params)
          .$promise;

      } else {
              var parameters = {
                bca: account.bca,
                rca: account.rca,
                transactionIds: transactionIds,
                page: pagination.currentPage,
                size: pagination.size
              };

              return $resource(BASE_URI + 'findUnmatchedReceipts')
                .get(parameters)
                .$promise;
      }
    };
    
    self.findByBillingCycles = function (pagination, endDates, cardId) {
      var account = TransactionSearchModel.account();

      var parameters = {
        bca: account.bca,
        rca: account.rca,
        cardId: cardId? cardId: account.cardId,
        endDates: endDates,
        page: pagination.currentPage,
        size: pagination.size
      };

      return $resource(BASE_URI + 'findByBillingCycle')
        .get(parameters)
        .$promise;
    };

    self.findMatchedByBillingCycles = function (pagination, endDates, cardId) {
      var account = TransactionSearchModel.account();
      var parameters;

      if (TransactionSearchModel.isBcaManager()) {
        parameters = {
          bca: account.bca,
          rca: account.rca,
          cardId: cardId? cardId: account.cardId,
          endDates: endDates,
          page: pagination.currentPage,
          size: pagination.size
        };

        return $resource(BASE_URI + 'findMatchedByBillingCycle')
          .get(parameters)
          .$promise;
      } else if (TransactionSearchModel.isAccountingManager()) {
        parameters = {
          siteNumber: account.siteNumber,
          linkKey: account.linkKey,
          concatValue: account.concatValue,
          cardId: cardId? cardId: account.cardId,
          endDates: endDates,
          page: pagination.currentPage,
          size: pagination.size
        };

        return $resource(BASE_URI + 'findMatchedByBillingCycleForAccountingLines')
          .get(parameters)
          .$promise;
      }
    };


    self.deleteReceipt = function deleteReceipt(receipt) {
      var parameters = {
        id: receipt.id
      };

      return $resource('/api/v1/receipts')
        .delete(parameters)
        .$promise
        .then(function (response) {
          return response;
        });
    };

    function nonBcaUpload(receipt, billingCycle) {
      return {
        url: '/api/v1/receipts',
        data: {
          file: receipt.file,
          rca: billingCycle.rca,
          bca: billingCycle.bca,
          endDate: billingCycle.endDate,
          cardId: billingCycle.cardId,
          receiptDetailsDescription: receipt.details.description,
          receiptDetailsAmount: receipt.details.amount,
          receiptDetailsDate: receipt.details.date
        }
      };
    }

    function amUpload(receipt) {
    var transaction =  ActiveTransactionModel.activeTransaction();
    transaction = !transaction ? SelectedTransactionService.selectedTransactions()[0] : transaction;
    var getAllReceiptDetails = {
         file: receipt.file,
         endDate: transaction.billingDate,
         transactionId: transaction.id,
         receiptDetailsDescription: receipt.details.description,
         receiptDetailsAmount: receipt.details.amount,
         receiptDetailsDate: receipt.details.date
    };
     return {
            url: '/api/v1/amReceipts',
            data:  getAllReceiptDetails
          };
        }

    function bcaUpload(receipt, billingCycle) {
      var transaction =  ActiveTransactionModel.activeTransaction();
      transaction = !transaction ? SelectedTransactionService.selectedTransactions()[0] : transaction;

      return {
        url: '/api/v1/bcaReceipts',
        data: {
          file: receipt.file,
          endDate: billingCycle.endDate,
          transactionId: transaction.id
        }
      };
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/ReceiptRepository.js
// module id = 619
// module chunks = 0